import React from 'react';
import {Linking, View} from 'react-native';
import {
  Container,
  FormBlock,
  MaxWidth,
  Menu,
  Text,
  VMargin,
} from '../../components/Elements';
import {OwnerContainer} from '../../container';
import {CommonStyles} from '../../theme';

const SUPPORT_SITE_URL = 'https://support.shop.trip-mile.com/hc/ja';

const Main: React.FC = React.memo(() => {
  const {owner} = OwnerContainer.useContainer();

  // AI START id=f3a9c model=arn:aws:bedrock:ap-northeast-1:085819009819:application-inference-profile/zxwfko5ajdj3 date=2026-07-31 task=update-suspend-screen-copy diff=B
  return (
    <Container>
      <MaxWidth maxWidth={1008} style={CommonStyles.margin.all}>
        <Menu>企業停止中</Menu>
        <VMargin />
        <View style={CommonStyles.flex.full}>
          <View>
            <FormBlock>
              <MaxWidth maxWidth={586}>
                <Text>
                  現在、お客様の企業アカウント（{owner?.hojin}
                  ）は以下のいずれかの理由により、ご利用を停止させていただいております。配信中の広告につきましては、全て停止しております。
                </Text>
                <VMargin />
                <Text>
                  ■
                  ご利用料金の決済エラーまたはお支払いの遅延：クレジットカードの有効期限切れ等により、決済エラーが発生しております。お支払い情報を更新・決済いただいた後、お手数ですが下記お問い合わせ窓口よりご一報ください。速やかに再開手続きを行います。
                </Text>
                <VMargin />
                <Text>
                  ■
                  利用規約違反または不正利用の検知：利用規約に反する行為、または不正利用が確認されたため、アカウントを停止しております。本措置に身に覚えがない場合、または異議がある場合は、下記お問い合わせ窓口までご連絡ください。
                </Text>
                <VMargin />
                <Text>
                  <Text
                    style={CommonStyles.linkText}
                    onPress={() => Linking.openURL(SUPPORT_SITE_URL)}
                  >
                    お問い合わせ
                  </Text>
                </Text>
                <VMargin />
                <VMargin />
                <Text>
                  トリマビジネスアカウントの削除をご希望の方は
                  <Text
                    style={CommonStyles.linkText}
                    onPress={() => Linking.openURL(SUPPORT_SITE_URL)}
                  >
                    こちら
                  </Text>
                  からお問い合わせをお願いいたします。
                </Text>
                <Text>
                  ※未払いの利用料金が残っている場合は、お支払いが全て完了した後に削除されます。
                </Text>
              </MaxWidth>
            </FormBlock>
            <VMargin />
          </View>
        </View>
      </MaxWidth>
    </Container>
  );
  // AI END id=f3a9c
});


export const Suspend = {
  Main,
};
